import React from "react";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../Router/constant";

export default function OtherCampaignsAdvisor({
  campaigns,
  isAdvisorUser,
  disableLinks = false,
}) {
  const navigate = useNavigate();
  return (
    <div className="caAnalyticsBar">
      <div className="caAnalyticsBarHeader">
        <h3 className="m-0">Campaigns by this {isAdvisorUser ? "partner" : "company"}</h3>
      </div>

      <div className="advisoraboutOuter">
        {campaigns?.length > 0 ? (
          campaigns?.slice(0, 5)?.map((campaign, index) => (
            <div
              onClick={() => {
                if (disableLinks) return;

                navigate(
                  RoutesPaths.PEOPLE_AI_BASE.replace(
                    ":id",
                    campaign?.slug ? campaign?.slug : campaign?._id,
                  ),
                );
              }}
              className="campaignLink"
              key={index}
            >
              <p className="m-0">
                {campaign?.name} - {campaign?.createdAt}
              </p>
            </div>
          ))
        ) : (
          <div className="campaignNotFound">
            {isAdvisorUser ? (
              <img src="/assets/img/noOtherCampaign.svg" alt="" />
            ) : (
              <img src="/assets/img/nocompanyCampaign.svg" alt="" />
            )}

            <h6 className="m-0">No other campaigns</h6>
            <p className="m-0">
              This {isAdvisorUser ? "partner" : "company"} hasn’t created any additional campaigns yet. Check
              back later for more opportunities.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
